import { AddressMap, Participants } from 'src/graphql';
import { CustomView } from 'src/graphql/entities/custom-view';
import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ConversationViewState {
  friendlyIdToUuidMap: Record<string, string>;
  selectedCustomView: CustomView | null;
  participantPlaceholders: Participants;
  associatedAddressesPlaceholders: AddressMap;
  conversationSidePanelStateOpen: boolean;
  setParticipantPlaceholders: (data: Participants) => void;
  setAssociatedAddressesPlaceholders: (data: AddressMap) => void;
  setConversationSidePanelStateOpen: (data: boolean) => void;
  addFriendlyIdToUuidItem: (uuid: string, friendlyId: string) => void;
  runGC: () => void;
}

export const createConversationViewSlice: StateCreator<
  ConversationViewState,
  [],
  [],
  ConversationViewState
> = (set) => ({
  friendlyIdToUuidMap: {},
  selectedCustomView: null,
  participantPlaceholders: {},
  associatedAddressesPlaceholders: {},
  conversationSidePanelStateOpen: true,
  setParticipantPlaceholders: (data) =>
    set((state) => ({
      participantPlaceholders: {
        ...state.participantPlaceholders,
        ...data,
      },
    })),
  setAssociatedAddressesPlaceholders: (data) =>
    set((state) => ({
      associatedAddressesPlaceholders: {
        ...state.associatedAddressesPlaceholders,
        ...data,
      },
    })),
  setConversationSidePanelStateOpen: (data) =>
    set(() => ({
      conversationSidePanelStateOpen: data,
    })),
  addFriendlyIdToUuidItem: (uuid, friendlyId) =>
    set((state) => ({
      friendlyIdToUuidMap: { ...state.friendlyIdToUuidMap, [friendlyId]: uuid },
    })),
  runGC: () => ({
    associatedAddressesPlaceholders: {},
    participantPlaceholders: {},
    selectedCustomView: null,
  }),
});

const useConversationViewsStore = create<ConversationViewState>()(
  persist(
    (...args) => ({
      ...createConversationViewSlice(...args),
    }),
    {
      name: 'portal-conversation-view-store',
      partialize: (state) => {
        // exclude placeholders from being persisted
        const { participantPlaceholders, associatedAddressesPlaceholders, ...persistedState } =
          state;
        return persistedState;
      },
    },
  ),
);

export default useConversationViewsStore;
